import axios from 'axios';

export default {
  state: {
    brand: [],
    loading: false,
    error: null,
    loaded: false // Добавляем флаг, который указывает, были ли загружены данные
  },
  mutations: {
    SET_BRAND(state, brand) {
      state.brand = brand.data;
      state.loaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {
    async fetchBrand({ commit, state, rootState}) {
      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/brand/', {params: {gender: rootState.gender.gender}});
        commit('SET_BRAND', response.data);
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message || 'Ошибка при загрузке');
        console.error('Error fetching brand:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
      brand: state => state.brand,
    brandLoading: state => state.loading,
    brandError: state => state.error,
    brandLoaded: state => state.loaded // Добавляем новый геттер
  }
}